import { Model } from "@interfaces/model.interface";

export interface ToolOrder extends Model {
	billetEstimatedFinishingHours?: number;
	billetEstimatedRoughingHours?: number;
	billetEstimatedTotalHours?: number;
	billetFinishedMass?: number;
	billetHeight?: number;
	billetLength?: number;
	billetSurfaceArea?: number;
	billetWidth?: number;
	dateRequired?: Date;
	estimatedCycleTime?: number;
	estimatedRunTime?: number;
	estimatedSetupTime?: number;
	estimatedStartDate?: Date;
	imageUrl?: string;
	isComplete: boolean;
	material?: number;
	name: string;
	productionToolId: number;
	specialInstructions: string;
	status?: number;
}

export class ToolOrder implements ToolOrder {
	isComplete = false;
	name = "";
	productionToolId = 0;
	specialInstructions = "";
	constructor(data?: Partial<ToolOrder>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
